/* Breadcrumb truncation — CSS-only approach to avoid forced reflow */
(function(){
  const textEl = document.getElementById('breadcrumb-text');
  if (!textEl) return;

  /* Use CSS text-overflow instead of JS layout thrashing.
     This avoids the forced reflow that occurred when reading
     scrollWidth/offsetWidth in a loop. */
  textEl.style.cssText = 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;display:inline-block';

  /* Let the parent flex/grid handle the available width calculation
     instead of manually measuring sibling widths */
  const container = textEl.parentElement;
  if (container) {
    container.style.cssText += ';display:flex;align-items:center;overflow:hidden;min-width:0';
    textEl.style.cssText += ';flex:1;min-width:0';
  }
})();